import axios, { AxiosResponse } from "axios";
import { TrendingCourseType } from "../../Utils/types";
import APIService from "../API";
import { ApplicationJsonConfigHeader, BaseUrl } from "../axios.config";
import {
  AuthenticationError,
  GeneralError,
  NetworkError,
  Payload,
} from "../Error.type";
import { DashboardDetailData } from "./Dashboard.types";


const dashboardUrl: string = BaseUrl + "/dashboard/student";
const trendingCourseURL: string = `${BaseUrl}/trendingCourses`;

const apiService = new APIService();
export class DashboardResult
  implements Payload<DashboardDetailData, NetworkError> {
  statusCode: number;
  data: DashboardDetailData;
  error?: NetworkError;
  errorMsg?: NetworkError;

  constructor(
    statusCode: number,
    data: DashboardDetailData,
    error?: NetworkError,
    errorMsg?: NetworkError
  ) {
    this.statusCode = statusCode;
    this.data = data;
    this.error = error;
    this.errorMsg = errorMsg;
  }
}
export class TrendingCourseResult
  implements Payload<TrendingCourseType, NetworkError> {
  statusCode: number;
  data?: TrendingCourseType;
  error?: NetworkError;
  errorMsg?: NetworkError;

  constructor(
    statusCode: number,
    data: TrendingCourseType,
    error?: NetworkError,
    errorMsg?: NetworkError
  ) {
    this.statusCode = statusCode;
    this.data = data;
    this.error = error;
    this.errorMsg = errorMsg;
  }
}

export class DashboardService {
  getDashboard = async (): Promise<DashboardResult> => {
    const res = await apiService.getReqs({
      APIUrl: dashboardUrl,
      payload: {},
      resType: DashboardResult,
    });
    return res as unknown as DashboardResult;
  };

  // Get Trending Courses data
  getTrendingCourse = async (): Promise<TrendingCourseResult> => {
    const res = await apiService.getReqs({
      APIUrl: trendingCourseURL,
      payload: "",
      resType: TrendingCourseResult,
    });
    return res as unknown as TrendingCourseResult;
  };
}
